import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: "",
    userInfo: {},
    signupStepsInfo: {
      progressIndex: 1,
      totalPrice: 0,
      ticketNum: 0,
      ticketList: [],
      attendeeInfo: null,
      attendeeMobile: null,
      attendeeName: null,
      company: null,
      email: null,
      profession: null,
      idCard: null,
      orderName: "",
      fillInfo: true,
    }
  },
  mutations: {
    setAppToken(state, token) {
      state.token = token;
    },
    // 设置用户信息
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    // 设置活动步骤信息
    setStepsInfo(state, data) {
      for (const key in data) {
        state.signupStepsInfo[key] = data[key];
      }
    }
  },
  actions: {
    // 异步保存活动步骤信息
    setSignupStepsInfoAsync(context, signupStepsInfo) {
      context.commit("setStepsInfo", signupStepsInfo);
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js